import {Component, Input, OnInit} from '@angular/core';
import {TaskService} from "../../services/task.service";
import {UtilsModule} from "../../utils/utils.module";

@Component({
  selector: 'nf-last-updated',
  templateUrl: './last-updated.component.html',
  styleUrls: ['./last-updated.component.css']
})
export class LastUpdatedComponent implements OnInit {

  @Input() pulseId;
  @Input() boardData;
  userData = [];
  updatedAt;
  updater;
  updaterName;
  color;
  timer;
  timeText;
  constructor(
    private taskService: TaskService,
    private utilsModule: UtilsModule
  ) { }

  ngOnInit(): void {
    if (this.boardData) {
      this.userData = this.boardData.boardData.users ? this.boardData.boardData.users : [];
    }
    if (this.pulseId) {
      this.review();
      // this.timer = setInterval(() => {
      //   this.review();
      // }, 60000);
    }
  }

  review() {
    this.taskService.getPulseData(this.pulseId).subscribe(res => {
      if (res) {
        this.updatedAt = res.updatedAt;
        this.updater = res.updater;
        this.updaterName = res.updaterName;
        if (this.userData) {
          for (const item of this.userData) {
            if (item.id == this.updater) {
              this.color = item.color;
              if (!this.color) {
                this.color = this.utilsModule.getRandomColor();
              }
              break;
            }
          }
        }
        this.calculateTime();
      }
    });
  }

  calculateTime() {
    if (!this.updatedAt) {
      this.timeText = '--';
    } else {
      const timeStamp = new Date().valueOf();
      const diff = (timeStamp - this.updatedAt)/ 1000; // 转换为秒
      if (diff < 60) {
        this.timeText = '刚才';
      } else if (diff >= 60 && diff < 3600) {
        const minutes = Math.floor(diff / 60); // 转换为分钟
        this.timeText = minutes + '分钟前';
      } else if (diff >= 3600 && diff < 86400) {
        const hours = Math.floor(diff / 3600); // 转换为小时
        this.timeText = hours + '小时前';
      } else if (diff >= 86400 && diff < 86400 * 7) {
        const days = Math.floor(diff / 86400); // 转换为天
        this.timeText = days + '天前';
      } else if (diff >= 86400 * 7 && diff < 86400 * 28) {
        const weeks = Math.floor(diff / 604800); // 转换为周
        this.timeText = weeks + '周前';
      } else if (diff >= 86400 * 28 && diff < 86400 * 30 * 12) {
        if (diff < 86400 * 30) {
          this.timeText = '1月前';
        } else {
          const months = Math.floor(diff / 2592000); // 转为为月(30天)
          this.timeText = months + '月前';
        }
      } else {
        const years = Math.floor(diff / 31104000); // 转换为年(360天)
        this.timeText = years + '年前';
      }
    }
  }
}
